import { css } from '@emotion/react';

// ── Desktop nav ─────────────────────────────────────────────────

const navStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 40px;
  background-color: #f8f8f5;
  width: 100%;
`;

const desktopContentStyles = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1360px;
  position: relative;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const logoStyles = css`
  height: 20px;
  flex-shrink: 0;

  svg {
    height: 100%;
    width: auto;
    display: block;
  }
`;

const menuStyles = css`
  display: flex;
  align-items: center;
  gap: 24px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`;

const menuItemStyles = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #111110;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  white-space: nowrap;
`;

const chevronStyles = css`
  width: 10px;
  height: 6px;
  flex-shrink: 0;
`;

const buttonsStyles = css`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

const loginStyles = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #111110;
  padding: 14px 16px;
  cursor: pointer;
  white-space: nowrap;
  background: none;
  border: none;
`;

const tryFreeStyles = css`
  font-family: 'FlodeskSans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #f0f0eb;
  background-color: #111110;
  border: none;
  border-radius: 50px;
  padding: 14px 24px;
  cursor: pointer;
  white-space: nowrap;
`;

// ── Tablet/Mobile nav ───────────────────────────────────────────

const mobileContentStyles = css`
  display: none;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1360px;
  height: 48px;
  position: relative;

  @media (max-width: 1024px) {
    display: flex;
  }
`;

const mobileLogoStyles = css`
  height: 18px;

  svg {
    height: 100%;
    width: auto;
    display: block;
  }
`;

const hamburgerStyles = css`
  position: absolute;
  right: 13px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  padding: 8px;
  background: none;
  border: none;
  cursor: pointer;
`;

const hamburgerLineStyles = css`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 16px;
`;

const lineStyles = css`
  height: 1.5px;
  width: 100%;
  background: #111110;
`;

// ── Icons ───────────────────────────────────────────────────────

function FlodeskLogo() {
  return (
    <svg viewBox="0 0 600 127" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M150.952 31.8408C178.569 31.8408 198.638 52.0406 198.638 79.2588C198.638 106.477 178.569 126.507 150.952 126.507C122.993 126.507 103.439 106.477 103.438 79.2588C103.438 52.0406 122.993 31.8408 150.952 31.8408ZM150.952 49.9863C134.485 49.9863 123.851 62.4834 123.851 79.0879C123.851 96.2068 134.486 108.532 150.952 108.532C167.591 108.532 177.883 96.0347 177.883 79.0879C177.883 62.6543 167.419 49.9863 150.952 49.9863Z"
        fill="#111110"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M370.34 31.8408C400.014 31.8408 416.139 53.5815 416.139 80.1152C416.139 81.3133 416.139 83.5389 415.968 85.251H343.925C344.611 100.144 356.961 109.217 371.369 109.217C381.146 109.217 389.38 104.766 394.526 96.207L414.424 99.8018C408.763 116.92 389.895 126.335 370.512 126.335C342.724 126.335 323.513 106.82 323.513 79.2588C323.513 52.3834 342.895 31.841 370.34 31.8408ZM370.34 48.6172C356.275 48.6174 346.326 57.3488 344.268 69.6738H394.869C392.982 56.4923 384.234 48.6172 370.34 48.6172Z"
        fill="#111110"
      />
      <path
        d="M464.852 31.498C483.891 31.498 497.272 41.94 498.644 58.5449L479.261 59.2305C477.717 52.5537 472.399 47.7607 463.822 47.7607C455.418 47.7608 450.444 51.8689 450.443 57.6885C450.443 62.4823 453.359 64.7076 460.563 67.1045L477.888 73.0957C492.296 78.0604 500.702 83.8804 500.702 97.5752C500.702 116.235 485.435 126.334 464.852 126.334C444.096 126.334 429.859 116.234 428.487 98.4307L448.899 97.5752C449.414 104.251 454.903 110.414 465.023 110.414C474.457 110.414 479.602 105.964 479.603 99.8008C479.603 93.8095 475.658 91.7549 466.053 88.5029L453.359 84.3936C438.78 79.7719 429.86 72.7535 429.859 59.4014C429.859 42.6254 443.925 31.4981 464.852 31.498Z"
        fill="#111110"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M304.812 124.104H285.772V117.599C285.772 115.202 285.773 113.319 286.116 111.778H285.43C279.254 120.851 268.276 126.158 255.24 126.158C229.51 126.158 211.843 106.3 211.843 79.4248C211.843 52.5486 229.51 32.0061 254.382 32.0059C267.59 32.0059 278.569 37.6557 284.4 45.873H284.915C284.744 36.4576 284.572 34.0608 284.572 23.4473V0.507812H304.812V124.104ZM259.014 50.3232C242.547 50.3234 232.255 63.3335 232.255 79.2529C232.255 95.5161 242.718 108.354 259.014 108.354C275.138 108.354 285.772 95.6871 285.772 79.082C285.772 62.8194 275.138 50.3232 259.014 50.3232Z"
        fill="#111110"
      />
      <path
        d="M42.5391 0C44.4263 0 46.3133 0.00042364 48.543 0.342773V17.9746C47.857 17.8032 47.3416 17.8037 46.4844 17.8037C38.9376 17.8038 33.9633 20.3713 32.9346 27.5605C32.7627 29.1017 32.7627 30.1288 32.7627 31.499V34.0664H48.543V51.1846H32.9346V124.109H12.6934V51.1846H0V34.0664H12.6934V30.9854C12.6934 11.6416 21.4416 0.000114263 42.5391 0Z"
        fill="#111110"
      />
      <path d="M84.7314 124.104H64.1475V0.507812H84.7314V124.104Z" fill="#111110" />
      <path
        d="M538.935 28.2393C538.935 43.3037 538.592 52.719 538.42 66.0713L538.592 66.2432C544.938 59.3961 550.77 54.2601 557.288 47.584L570.496 34.0605H598.456L550.599 76.5137L600 124.104H571.012C559.69 112.805 548.712 100.994 538.764 89.8672H538.592C538.764 97.3989 538.935 103.562 538.935 112.12V124.104H518.866V0.507812H538.935V28.2393Z"
        fill="#111110"
      />
    </svg>
  );
}

function ChevronDown() {
  return (
    <svg css={chevronStyles} viewBox="0 0 10 6" fill="none">
      <path
        d="M1 1L5 5L9 1"
        stroke="#111110"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// ── Component ───────────────────────────────────────────────────

type NavigationProps = {
  onLogoClick: () => void;
  onTryFreeClick: () => void;
  onLoginClick: () => void;
  onPricingClick: () => void;
};

export default function Navigation({
  onLogoClick,
  onTryFreeClick,
  onLoginClick,
  onPricingClick,
}: NavigationProps) {
  const logoClickProps = {
    onClick: onLogoClick,
    css: css`
      ${logoStyles};
      cursor: pointer;
    `,
    role: 'button' as const,
    tabIndex: 0,
  };

  const mobileLogoClickProps = {
    onClick: onLogoClick,
    css: css`
      ${mobileLogoStyles};
      cursor: pointer;
    `,
    role: 'button' as const,
    tabIndex: 0,
  };

  return (
    <nav css={navStyles}>
      {/* Desktop */}
      <div css={desktopContentStyles}>
        <div {...logoClickProps} aria-label="Flodesk">
          <FlodeskLogo />
        </div>
        <div css={menuStyles}>
          <span css={menuItemStyles}>
            Products <ChevronDown />
          </span>
          <span css={menuItemStyles}>
            Resources <ChevronDown />
          </span>
          <span css={menuItemStyles}>Templates</span>
          <span
            css={menuItemStyles}
            onClick={onPricingClick}
            onKeyDown={e => {
              if (e.key === 'Enter') onPricingClick();
            }}
            role="button"
            tabIndex={0}
          >
            Pricing
          </span>
        </div>
        <div css={buttonsStyles}>
          <button css={loginStyles} type="button" onClick={onLoginClick}>
            Log In
          </button>
          <button css={tryFreeStyles} type="button" onClick={onTryFreeClick}>
            Try it free
          </button>
        </div>
      </div>

      {/* Tablet / Mobile */}
      <div css={mobileContentStyles}>
        <div {...mobileLogoClickProps} aria-label="Flodesk">
          <FlodeskLogo />
        </div>
        <button css={hamburgerStyles} type="button" aria-label="Menu">
          <div css={hamburgerLineStyles}>
            <div css={lineStyles} />
            <div css={lineStyles} />
          </div>
        </button>
      </div>
    </nav>
  );
}
